import type { LayoutComponentScreen } from '../types';
import {
  BalancesScreen,
  ChartScreen,
  CreditScreen,
  LadderScreen,
  OrderCardsScreen,
  OrderFormsScreen,
  TradesScreen,
  TransfersScreen,
  WatchListScreen,
} from './screenLibrary';

export interface MobileLayoutComponentScreen extends LayoutComponentScreen {
  params?: Record<string, string>;
}

export const tradingMobileScreens: MobileLayoutComponentScreen[] = [
  {
    ...WatchListScreen,
    params: {
      securityRoute: LadderScreen.path,
    },
  },
  LadderScreen,
  OrderFormsScreen,
  OrderCardsScreen,
  BalancesScreen,
  TradesScreen,
  CreditScreen,
  TransfersScreen,
];

export const tradingMobileChartScreens: MobileLayoutComponentScreen[] = [
  {
    ...WatchListScreen,
    params: {
      securityRoute: ChartScreen.path,
    },
  },
  ChartScreen,
  OrderFormsScreen,
  OrderCardsScreen,
  BalancesScreen,
  TradesScreen,
  CreditScreen,
  TransfersScreen,
];
